import { LoginPostModel } from "../../Models/LoginModel/LoginPostModel";
// @ts-ignore
import { LoginResponseModel } from "../../Models/LoginModel/LoginResponseModel.ts";
// @ts-ignore
import axiosInstance from "../BaseService.ts";

export default async function LoginSurvice(user: LoginPostModel): Promise<any> {
  let Temp: LoginResponseModel = new LoginResponseModel("", "", "");
  await axiosInstance
    .post("user/login", user, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
    .then((response) => {
      Temp = response.data;
    });
  return Temp;
}
